import { Collapse } from '@material-ui/core'
import React from 'react'
import EyeClose from '../../../../assets/images/eye-close-red.svg'
import EyeSvg from '../../../../assets/images/eye-purple.svg'

const ListItem = (props) => {
  const [expanded, setExpanded] = React.useState(true)
  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  return (
    <>
      <div className='containerListItem' onClick={handleExpandClick} aria-expanded={expanded}>
        {props.img !== null && <img src={props.img} alt={'logo'} />}
        <p className={props.img=== null && 'no-image'}>{props.desc} ({props.cant})</p>
        {expanded ? <img src={EyeClose} alt='ocultar' /> : <img src={EyeSvg} alt='mostrar' />}
        <span className={expanded ? 'no-showing' : null}>{expanded ? 'Ocultar productos' : 'Mostrar productos'}</span>
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {props.children}
      </Collapse>

      <style jsx>{`
        .containerListItem{
          display: flex;
          align-items:center;
          margin: .5rem .5rem .5rem 0;
        }
        p{
          flex-grow:1;
          margin-left: .5rem;
          font-size: .8em;
        }
        .no-image{
          margin-left: 0;
        }
        span{
          margin-left: .5rem;
          font-size: .7em;
          color: var(--main-primary-color);
        }
        .no-showing{
          color: var(--ripley-red);
        }
      `}</style>
    </>
  )
}

export default ListItem
